import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminUser(props) {
    const formuserRef = useRef(null)
    const usernameRef = useRef(null)

    const [userlist, setUserlist] = useState([]);
    const [useritem, setUseritem] = useState({
        id: 0,
        username: '',
        password: '',
        status: '',
        user_role: '',
        firstname: '',
        lastname: ''
    });
    const [mode, setMode] = useState('');
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_user, setModal_user] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    useEffect(() => {
        api_get_list()
        return () => {
            setUserlist([])
        };
    }, []);

    async function api_get_list() {
        setmodal_load({ enable: true, message: "Loading user list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/user/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setUserlist(response.data.user)
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    function checkEnable(status) {
        if (status === 'Enable') {
            return <td><i className="far fa-check-circle icon-green"></i> {status}</td>
        }
        else {
            return <td><i className="far fa-circle"></i> {status}</td>
        }
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-users-cog"></i> Users Authentication</h4>
                                    <p className="mb-3">Manage all users authentication</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_get_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Users Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th className="id-fixwidth">No.</th>
                                        <th>Username</th>
                                        <th>Status</th>
                                        <th>User Role</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Edit Time</th>
                                        <th className="text-center" style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        userlist?.map((user, index) => (
                                            <tr key={user.id}>
                                                <td><i className="fas fa-user-shield rows-icon"></i> {index + 1}</td>
                                                <td>{user.username}</td>
                                                {checkEnable(user.status)}
                                                <td>{user.user_role}</td>
                                                <td>{user.firstname}</td>
                                                <td>{user.lastname}</td>
                                                <td>{moment(new Date(user.edittime)).format('YYYY-MMM-DD HH:mm:ss')}</td>
                                                <td>
                                                    <Link className="btn btn-icon btn-sm btn-hover btn-bordered mx-1" title="View" onClick={() => { setUseritem(user); setModal_user(true) }}><i className="fas fa-search"></i></Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>


                    {
                        modal_user ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-users-cog"></i> User Authentication</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_user(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formuserRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="username">Username</label>
                                                                <input type="text" className="form-control" name="username" ref={usernameRef} value={useritem.username} onChange={(e) => {
                                                                    setUseritem({
                                                                        ...useritem,
                                                                        username: e.target.value
                                                                    })
                                                                }} required readOnly />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="password">Password</label>
                                                                <input type="password" className="form-control" name="password" pattern=".{4,}" value={useritem.password} onChange={(e) => {
                                                                    setUseritem({
                                                                        ...useritem,
                                                                        password: e.target.value
                                                                    })
                                                                }} required readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="firstname">First name</label>
                                                                <input type="text" className="form-control" name="firstname" value={useritem.firstname} onChange={(e) => {
                                                                    setUseritem({
                                                                        ...useritem,
                                                                        firstname: e.target.value
                                                                    })
                                                                }} required readOnly />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="lastname">Last name</label>
                                                                <input type="text" className="form-control" name="lastname" value={useritem.lastname} onChange={(e) => {
                                                                    setUseritem({
                                                                        ...useritem,
                                                                        lastname: e.target.value
                                                                    })
                                                                }} required readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <label htmlFor="user_role">User Role</label>
                                                            <input type="text" className="form-control" name="user_role" value={useritem.user_role} onChange={(e) => {
                                                                setUseritem({
                                                                    ...useritem,
                                                                    user_role: e.target.value
                                                                })
                                                            }} required readOnly />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="status">Status</label>
                                                            <input type="text" className="form-control" name="status" value={useritem.status} onChange={(e) => {
                                                                setUseritem({
                                                                    ...useritem,
                                                                    status: e.target.value
                                                                })
                                                            }} required readOnly />
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_user(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminUser